import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { DICTS } from "@/lib/i18n";

export const Route = createFileRoute("/account/media")({
  component: lazyRouteComponent(() => import("./-pages/account.media")),
  head: () => ({
    meta: [
      { title: DICTS.en["account.media.meta_title"] ?? "Ambassador Media — Lecmo" },
      {
        name: "description",
        content:
          DICTS.en["account.media.meta_desc"] ??
          "Ready-to-share content for Lecmo ambassadors.",
      },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
});
